import React from 'react';
import styled from 'styled-components';
import Cards from 'components/Core/Cards';
import { STSubscribeForm } from 'components/Form/STSubscribeForm';
import WistiaVideo from 'components/Core/WistiaVideo';

const ReviewHeroSection = ({ background, title, description, review, ...otherProps }) => {
  return (
    <SectionContainer background={background} {...otherProps}>
      <div className="section-review-hero--wrapper">
        <div className="section-review-hero--container">
          <h2 className="section-review-hero--title">{title}</h2>
          <p className="section-review-hero--description">{description}</p>
          <div className="section-review-hero--subscribe-content">
            <STSubscribeForm
              buttonTitle="Get Demo"
              buttonLinkTo="/demo"
              className="section-review-hero--subscribe-form"
              dataPosition="Hero"
            />
          </div>
          <div className="section-review-hero--main">
            <div className="section-review-hero--review-content">
              <Cards
                bodyType={'review'}
                companyLogo={review.companyLogo}
                quote={review?.quote?.quote}
                author={review.author}
                company={review.companyPosition}
                width="100%"
                noShadow={true}
              />
            </div>
            <div className="section-review-hero--video-content">
              <div className="section-review-hero--video-container">
                {review.wistiaVideo && (
                  <WistiaVideo
                    dataPosition="Hero"
                    url={review.wistiaVideo}
                    wrapperStyles={{ height: '100%' }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </SectionContainer>
  );
};

const SectionContainer = styled.div`
  background: white;
  height: 1100px;
  .section-review-hero--wrapper {
    background: ${props => props.background};
    height: 700px;
  }

  .section-review-hero--container {
    margin: 0 auto;
    padding: 220px 0 91px;

    .section-review-hero--title {
      font-size: 61px;
      line-height: 110%;
      text-align: center;
      letter-spacing: -0.05em;
      color: var(--white-color);
      max-width: 1000px;
      margin: 0 auto;
      padding: 0 28px;
    }

    .section-review-hero--description {
      color: var(--white-color);
      text-align: center;
      max-width: 800px;
      margin: 0 auto;
      margin-top: 50px;
      padding: 0 28px;
    }

    .section-review-hero--subscribe-content {
      margin-top: 81px;
      padding: 0 28px;

      .section-review-hero--subscribe-form {
        justify-content: center;
      }
    }

    .section-review-hero--main {
      max-width: 1182px;
      margin: 0 auto;
      margin-top: 92px;
      display: flex;

      .section-review-hero--review-content {
        max-width: 417px;
        margin-top: 100px;
      }

      .section-review-hero--video-content {
        width: 100%;
        padding: 0 54px;
        position: relative;
        overflow: hidden;

        .section-review-hero--video-container {
          position: relative;
          display: block;
          justify-content: end;
          height: 400px;

          .VideoMainDiv {
            box-shadow: 0px 40px 60px rgba(0, 0, 0, 0.15);
          }

          &:before {
            content: '';
            position: absolute;
            background: var(--secondary-green-background);
            width: 211px;
            height: 42px;
            bottom: -42px;
            right: -42px;
          }

          &:after {
            content: '';
            position: absolute;
            background: var(--secondary-green-background);
            width: 42px;
            height: 211px;
            bottom: -42px;
            right: -42px;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    height: 700px;

    .section-review-hero--wrapper {
      height: 385px;
    }

    .section-review-hero--container {
      margin: 0 auto;
      padding: 105px 0 91px;

      .section-review-hero--title {
        font-size: 36px;
        line-height: 44px;
        max-width: 590px;
      }

      .section-review-hero--description {
        font-size: 18px;
        line-height: 28px;
        margin-top: 20px;
        max-width: 590px;
      }

      .section-review-hero--subscribe-content {
        margin: 40px auto 0;
        max-width: 590px;

        .section-review-hero--subscribe-form {
          .text-field-input {
            height: 55px !important;
          }

          button {
            padding: 11px;
          }
        }
      }

      .section-review-hero--main {
        max-width: 1254px;
        margin: 0 auto;
        margin-top: 48px;
        display: flex;

        .section-review-hero--review-content {
          max-width: 353px;
          margin-top: 0;

          .ant-card-body {
            padding: 21px 28px;
          }
        }

        .section-review-hero--video-content {
          width: 100%;
          padding: 0 28px;
          position: relative;

          .section-review-hero--video-container {
            height: 250px;
            &:before,
            &:after {
              display: none;
            }
          }
        }
      }
    }
  }

  @media (max-width: 576px) {
    height: 850px;

    .section-review-hero--wrapper {
      height: 400px;
    }

    .section-review-hero--container {
      margin: 0 auto;
      padding-bottom: 0;

      .section-review-hero--title {
        font-size: 36px;
        line-height: 42px;
      }

      .section-review-hero--description {
        font-size: 20px;
        line-height: 28px;
        margin-top: 20px;
      }

      .section-review-hero--subscribe-content {
        margin: 40px auto 0;

        .section-review-hero--subscribe-form {
          flex-direction: column;

          .ant-row.ant-form-item {
            width: 100% !important;
            padding: 0 !important;
          }

          .text-field-input {
            height: 45px !important;
          }

          button {
            width: 100%;
            padding: 7px;
          }
        }
      }

      .section-review-hero--main {
        flex-direction: column-reverse;

        .section-review-hero--review-content {
          max-width: 100%;
          margin-top: 27px;

          .ant-card-body {
            padding: 21px 28px;
          }

          .review-card--content-container {
            .review-card--description {
              font-size: 18px;
              line-height: 28px;
            }
          }
        }

        .section-review-hero--video-content {
          padding: 0 28px;

          .section-review-hero--video-container {
            &:before {
              display: block;
              width: 100px;
              height: 13px;
              bottom: -13px;
              right: -13px;
            }

            &:after {
              display: block;
              width: 13px;
              height: 100px;
              bottom: -13px;
              right: -13px;
            }
          }
        }
      }
    }
  }
`;

export default ReviewHeroSection;
